/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA1Icon20Solid = forwardRef('DataChartPieA1Icon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.25 2.035a8 8 0 1 0 8.024 4.631l-6.899 3.983A.75.75 0 0 1 9.25 10V2.035Z" }),
        React.createElement("path", { d: "M10.75 2.035a7.994 7.994 0 0 1 5.773 3.333L10.75 8.7V2.035Z" })));
});
